import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { FileText, Plus, Download, Trash2 } from "lucide-react";
import type { DocumentFile } from "../../_types/assignment-types";

interface DocumentsTabProps {
  assignmentId: string;
  documents: DocumentFile[];
  onUploadDocument: () => void;
  onDeleteDocument: (documentId: string) => void;
}

export function DocumentsTab({
  assignmentId,
  documents,
  onUploadDocument,
  onDeleteDocument,
}: DocumentsTabProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <FileText className="h-5 w-5" />
              Documents
            </CardTitle>
            <CardDescription>
              Assignment-related documents and files
            </CardDescription>
          </div>
          <Button type="button" onClick={onUploadDocument}>
            <Plus className="h-4 w-4 mr-2" />
            Upload Document
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="flex items-center justify-between p-3 border rounded-lg"
            >
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <FileText className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <p className="font-medium">{doc.name}</p>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span>{doc.size}</span>
                    <span>Uploaded: {doc.uploadDate}</span>
                    <span>By: {doc.uploader}</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() =>
                    window.open(
                      `/api/files/download?assignmentId=${assignmentId}&documentId=${doc.id}`,
                      "_blank",
                    )
                  }
                >
                  <Download className="h-4 w-4" />
                </Button>
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => onDeleteDocument(doc.id)}
                  className="text-red-600 hover:text-red-700 hover:bg-red-50"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
